import React from 'react'

import type { GetServerSideProps, NextPage } from 'next'

import TheaterSubCategoryContent from '@/components/pages/theater/sub-category/components/sub-category-content'
import type { SubCategoryPageProps } from '@/components/shared/sub-category/types'
import { getServerSidePropsByCategoryId } from '@/components/shared/sub-category/utils'
import { CATEGORY_IDS } from '@/constants'
import { SubCategoryProvider } from '@/context/sub-category'

const TheaterSubCategoryPage: NextPage<SubCategoryPageProps> = (props) => {
    const { initialSubCategoryParams, initialSubCategory } = props
    return (
        <SubCategoryProvider
            initialParams={initialSubCategoryParams}
            initialProps={initialSubCategory ? { data: initialSubCategory } : undefined}
        >
            <TheaterSubCategoryContent {...props} />
        </SubCategoryProvider>
    )
}

TheaterSubCategoryPage.displayName = 'TheaterSubCategoryPage'

export const getServerSideProps: GetServerSideProps<SubCategoryPageProps> = getServerSidePropsByCategoryId(
    CATEGORY_IDS.THEATER,
)

export default TheaterSubCategoryPage
